"use clients";

import Button from "@/ui/Button";
import React from "react";
import Image from "next/image";
import errorImg from "@/images/contacts/error.webp";
import { useTranslations } from "next-intl";


interface Props {
  onAddContacts: () => void;
  isLoading?: boolean;
}

const ErrorContactsHolder: React.FC<Props> = (props) => {
  const t = useTranslations("HiddenFields");
  return (
    <div className="flex flex-col justify-center items-center">
      <p className="text-[#1B1B1B] font-normal text-[18px] tracking-normal text-center align-middle mb-[40px] lg:mb-[54px]">
        {t("errorPermission")}
        <br />
        {t("tryAgainError")}
      </p>
      <div className="relative w-full max-w-[254.53px] aspect-[254.53/224.38] mb-[32px] lg:mb-[45px]">
        <Image
          src={errorImg}
          alt={t("errorPermission")}
          fill
          priority
          sizes="(max-width: 640px) 100vw, 254.53px"
          className="object-contain"
        />
      </div>

      <Button
        color="red"
        type="button"
        onClick={props.onAddContacts}
        isLoading={props.isLoading}
      >
        {t("tryAgain")}
      </Button>
    </div>
  );
};

export default ErrorContactsHolder;
